<template lang="pug">
    v-container(fluid)
      VueSlickCarousel(
        :arrows="false" 
        :dots="false" 
        :infinite="true" 
        :pauseOnFocus="false" 
        :slidesToShow="computedSlidesToShow" 
        :slidesToScroll="1" 
        :speed="computedSpeed" 
        :loop="true"
        :autoplay="true" 
        :cssEase="'linear'"
        :autoplaySpeed="0"
      )
        img.img-slick-carousel(src="@/assets/logo/logo_rostemecom.svg")
        img.img-slick-carousel(src="@/assets/logo/logo_gazpromtrans.svg")
        img.img-slick-carousel(src="@/assets/logo/logo_ARDA.svg")
        img.img-slick-carousel(src="@/assets/logo/logo_UseTech.svg")
        img.img-slick-carousel(src="@/assets/logo/logo_gazpromNeft.svg")
        img.img-slick-carousel(src="@/assets/logo/logo_infocraft.svg")
        img.img-slick-carousel(src="@/assets/logo/logo_PROMO_IT.svg")
        img.img-slick-carousel(src="@/assets/logo/logo_rgd.svg")
        img.img-slick-carousel(src="@/assets/logo/logo_roskomnadzor.svg")
        img.img-slick-carousel(src="@/assets/logo/logo_itech.svg")
        img.img-slick-carousel(src="@/assets/logo/logo_croc.svg")
    </template>
  
  <script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  
  export default {
    name: "RunningLine",
    components: { VueSlickCarousel },
    computed: {
      computedSlidesToShow() {
        return this.$vuetify.breakpoint.lgAndUp ? 5 : 3;
      },
      computedSpeed() {
        return this.$vuetify.breakpoint.lgAndUp ? 20000 : 6500;
      }
    }
  }
  </script>
  
  <style scoped lang="sass">
    @import "scss/variables.scss"

    .img-slick-carousel
      width: 7rem !important
  
    @media (max-width: $xsOnly)
      .img-slick-carousel
        width: 5rem !important
        margin: 3rem 5px 0 
  </style>
  